module.exports = __webpack_public_path__ + "static/img/sgqi.3b7868d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sgqi.png
// module id = 2hNA
// module chunks = 0